import { generateUserQueryKeys } from 'src/libs/react-query';
import { Address } from 'viem';

export const authKeys = {
  authenticated: (userAddress: Address) => generateUserQueryKeys(userAddress, 'authenticated'),
};
